import {
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { CollecticonIsoStack, CollecticonTickSmall } from "@devseed-ui/collecticons-chakra";
import Overline from "./Overline";

export type BasemapOption = {
  id: string;
  name: string;
};

type Props = {
  options: BasemapOption[];
  activeId: string;
  onChange: (id: string) => void;
};

function BasemapSwitcher({ options, activeId, onChange }: Props) {
  const popoverBg = useColorModeValue("base.50", "base.700");
  const activeBg = useColorModeValue("base.100a", "base.500");

  return (
    <Popover placement="top-start">
      <PopoverTrigger>
        <IconButton
          aria-label="Change basemap"
          variant="base-soft-outline"
          bg={useColorModeValue("base.50", "base.500")}
          color={useColorModeValue("base.500", "base.50")}
          _hover={{
            bg: useColorModeValue("base.100", "base.700"),
            color: useColorModeValue("primary.600", "primary.500"),
            borderColor: useColorModeValue("primary.600", "primary.500")
          }}
          minW="9"
          title="Change basemap"
          position="absolute"
          bottom={8}
          right={4}
          zIndex="1020"
          icon={<CollecticonIsoStack />}
        />
      </PopoverTrigger>
      <PopoverContent w="12rem" bg={popoverBg}>
        <PopoverArrow />
        <PopoverBody>
          <Overline mb={2}>Basemap</Overline>
          <Box display="flex" flexDir="column" gap="1">
            {options.map((option) => {
              const isActive = option.id === activeId;
              return (
                <Box
                  key={option.id}
                  as="button"
                  type="button"
                  display="flex"
                  alignItems="center"
                  gap="2"
                  px="2"
                  py="1.5"
                  borderRadius="md"
                  textAlign="left"
                  bg={isActive ? activeBg : "transparent"}
                  onClick={() => onChange(option.id)}
                >
                  <Text fontSize="sm" flex="1">{option.name}</Text>
                  {isActive && <CollecticonTickSmall />}
                </Box>
              );
            })}
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default BasemapSwitcher;
